import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MenuService } from 'app/services/menu.service';

@Component({
  selector: 'solution-menu',
  templateUrl: './solution-menu.component.html',
  standalone: false,
})
export class SolutionMenuComponent {
  @Input() products: any[] = [];
  @Input() menuId;
  @Input() title;
  @Output() closeMenuEvent = new EventEmitter<boolean>();
  constructor(private menuService: MenuService) {}

  closeMenu() {
    this.closeMenuEvent.emit(true);
  }
}
